import { styled } from '@/stitches.config';
import { Card } from '@base-app';

export const StyledSampleTrackingCard = styled(Card, {
  borderRadius: '$4',
  boxShadow: 'none',
});
